"use strict";function setScreenBrightnessAndKeepOn$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.setScreenBrightnessAndKeepOn$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.util.setScreenBrightnessAndKeepOn";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"4.6.37"},_a[ddSdk_1.ENV_ENUM.android]={vs:"4.3.3"},_a)),exports.setScreenBrightnessAndKeepOn$=setScreenBrightnessAndKeepOn$,exports.default=setScreenBrightnessAndKeepOn$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/util/setScreenBrightnessAndKeepOn.js
// module id = 1025
// module chunks = 106